import React, { useContext } from 'react';
import { Box, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as CopilotChatButton } from '../../svg/mindtickle/mt-buyer-copilot-chat-button.svg';
import { OrganizationThemeContext } from '../../lib/context/OrganizationThemeContext';

const useStyles = makeStyles((theme: Theme) => ({
  root: (props: { backgroundColor?: string }) => ({
    backgroundColor: props.backgroundColor || 'var(--buyer-copilot-enabled)',
    color: 'var(--text-primary-light)',
    borderRadius: theme.spacing(2),
    padding: '2px 3px',
    marginRight: theme.spacing(0.5),
    verticalAlign: 'top',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    '& svg': { fill: 'currentColor' },
  }),
}));

const BuyerCopilotAvatarIcon: React.FC = () => {
  const { buttonsStyles } = useContext(OrganizationThemeContext);
  const classes = useStyles({
    backgroundColor: buttonsStyles?.backgroundColor,
  });

  return (
    <Box component="span" className={classes.root}>
      <CopilotChatButton />
    </Box>
  );
};

export default BuyerCopilotAvatarIcon;
